import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { authorizedFetch } from '@/lib/api'
import { fetchSignupPolicy, type SignupPolicy } from '@/lib/signup-policy'

export function useSignupPolicy() {
  return useQuery({
    queryKey: ['signup-policy'],
    queryFn: fetchSignupPolicy,
    staleTime: 30 * 1000,
  })
}

export function useUpdateSignupPolicy() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (requireApproval: boolean): Promise<SignupPolicy> => {
      const response = await authorizedFetch('/api/accounts/signup/policy', {
        method: 'PATCH',
        body: JSON.stringify({ require_approval: requireApproval }),
      })
      if (!response.ok) {
        const error = await response.json().catch(() => ({}))
        throw new Error(error.error || 'Failed to update signup policy')
      }
      return response.json()
    },
    onSuccess: (data) => {
      queryClient.setQueryData(['signup-policy'], data)
    },
  })
}
